// assets/quiz-modal.js
window.addEventListener('DOMContentLoaded', function () {
  // ====== CONFIG STOREFRONT ======
  const STOREFRONT_TOKEN = '495be658c9a93ba95807d1a826ef63ea';
  const API_VERSION = '2024-07';
  const SHOP_DOMAIN = (window.Shopify && window.Shopify.shop) || window.location.hostname;
  const SF_ENDPOINT = `https://${SHOP_DOMAIN}/api/${API_VERSION}/graphql.json`;

  // ====== WEBHOOK ======
  const WEBHOOK_URL = 'https://hooks.zapier.com/hooks/catch/18597039/u68hj0x/';
  
  // ====== STATE ======
  const answers = {
    step1_character: null, 
    step2_must: null,     
    step3_silhouette: null,
    step4_necklines: [],   
    step5_skirts: [],     
    email: null,
    subscribe: true,
  };

  const modal = document.getElementById('quiz-modal');
  const intro = document.querySelector('.quiz-intro');

  function setBackVisible(show) {
    const backBtn = document.getElementById('quiz-back');
    if (!backBtn) return;
    backBtn.style.display = show ? 'inline-block' : 'none';
  }

  // ====== UTILS HELPERS======
  function show(el){ if(el) el.style.display='block'; }
  function hide(el){ if(el) el.style.display='none'; }

  function goToStep(currentId, nextId){
    hide(document.getElementById(currentId));
    show(document.getElementById(nextId));
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }


  document.getElementById('quiz-step-1-continue')?.addEventListener('click', () => {

    if (!answers.step1_character){ 
      
      goToStep('quiz-step-1', 'quiz-step-2');
    } else {
      goToStep('quiz-step-1', 'quiz-step-2');
    }
    const step2El = document.getElementById('quiz-step-2');
    if (step2El) updateCTAForStep(step2El);
  });

  document.getElementById('quiz-step-2-continue')?.addEventListener('click', () => {

    goToStep('quiz-step-2', 'quiz-step-3');
    const step3El = document.getElementById('quiz-step-3');
    if (step3El) updateCTAForStep(step3El);
  });

  document.getElementById('quiz-step-3-continue')?.addEventListener('click', () => {
   
    goToStep('quiz-step-3', 'quiz-step-4');
    const step4El = document.getElementById('quiz-step-4');
    if (step4El) updateCTAForStep(step4El);
  });

  document.getElementById('quiz-step-4-continue')?.addEventListener('click', () => {
 
    goToStep('quiz-step-4', 'quiz-step-5');
    const step5El = document.getElementById('quiz-step-5');
    if (step5El) updateCTAForStep(step5El);
  });



  async function sfFetch(query, variables={}){
    const res = await fetch(SF_ENDPOINT, {
      method:'POST',
      headers:{
        'Content-Type':'application/json',
        'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN,
      },
      body: JSON.stringify({ query, variables })
    });
    const json = await res.json();
    if (json.errors) {
      console.error('[Storefront GQL] errors:', json.errors);
      throw new Error('Storefront GraphQL error');
    }
    return json.data;
  }

  function pickLastImageUrl(imageEdges){
    if(!imageEdges || !imageEdges.length) return null;
    const last = imageEdges[imageEdges.length - 1].node;
    return { url: last.url, alt: last.altText || '' };
  }

  function cardHTML({ title, imageUrl, alt, handle, id }){
    return `
      <div class="quiz-option" data-handle="${handle}" data-id="${id}">
        ${imageUrl
          ? `<img src="${imageUrl}" alt="${alt || title}">`
          : `<div class="configurator-placeholder" style="height:280px;display:flex;align-items:center;justify-content:center;border:1px dashed #ccc;border-radius:8px;">No image</div>`}
        <h3 class="name">${title}</h3>
      </div>
    `;
  }

  //CARGA DINÁMICA PASOS 4 (tops) y 5 (bottoms)
  const QUERY_QUIZ_PRODUCTS = `
    query QuizProducts($first:Int!, $topsQuery:String!, $bottomsQuery:String!) {
      tops: products(first:$first, query:$topsQuery) {
        nodes {
          id
          title
          handle
          images(first:250) {
            edges { node { url(transform:{maxWidth:720, crop:CENTER}) altText } }
          }
        }
      }
      bottoms: products(first:$first, query:$bottomsQuery) {
        nodes {
          id
          title
          handle
          images(first:250) {
            edges { node { url(transform:{maxWidth:720, crop:CENTER}) altText } }
          }
        }
      }
    }
  `;

  async function loadQuizProducts(){
    try{
      const data = await sfFetch(QUERY_QUIZ_PRODUCTS, {
        first: 50,
        topsQuery: `tag:'top' NOT tag:'hidden'`,
        bottomsQuery: `tag:'bottom' NOT tag:'hidden'`,
      });

      // Step 4 (tops)
      const step4Grid = document.querySelector('.quiz-options-grid.step-4');
      if(step4Grid){
        step4Grid.innerHTML = '';
        const tops = (data.tops?.nodes || []).map(n=>{
          const img = pickLastImageUrl(n.images?.edges || []);
          return { id:n.id, title:n.title, handle:n.handle, imageUrl:img?.url||null, alt:img?.alt||n.title };
        });
        if(!tops.length){
          step4Grid.innerHTML = `<p style="text-align:center">No tops found.</p>`;
        }else{
          tops.forEach(p => step4Grid.insertAdjacentHTML('beforeend', cardHTML(p)));
        }
      }

      // Step 5 (bottoms)
      const topRow = document.querySelector('.quiz-options-grid.step-5-row.top-row');
      const bottomRow = document.querySelector('.quiz-options-grid.step-5-row.bottom-row');
      if(topRow && bottomRow){
        topRow.innerHTML = ''; bottomRow.innerHTML = '';
        const bottoms = (data.bottoms?.nodes || []).map(n=>{
          const img = pickLastImageUrl(n.images?.edges || []);
          return { id:n.id, title:n.title, handle:n.handle, imageUrl:img?.url||null, alt:img?.alt||n.title };
        });
        if(!bottoms.length){
          topRow.innerHTML = `<p style="text-align:center">No bottoms found.</p>`;
        }else{
          bottoms.forEach((p,i)=>{
            const html = cardHTML(p);
            (i<4 ? topRow : bottomRow).insertAdjacentHTML('beforeend', html);
          });
        }
      }
    }catch(err){
      console.error('[Quiz] loadQuizProducts error:', err);
    }
  }

  function hasAnySelectionForStep(stepEl){
    return stepEl && stepEl.querySelector('.quiz-option.selected') !== null;
  }

  function getCTAButtonForStep(stepEl){
    if (!stepEl) return null;
    const n = stepEl.id.match(/\d+/)?.[0];
    if (!n) return null;
    return document.getElementById(`quiz-step-${n}-continue`);
  }

  function updateCTAForStep(stepEl){
    if (!stepEl) return;
    const hasSelection = stepEl.querySelector('.quiz-option.selected') !== null;
    const btn = stepEl.querySelector('.quiz-continue button');
    if (btn) btn.textContent = hasSelection ? 'Continue' : 'No Preference';
  }

  // ====== END UTILS HELPERS======

  // ====== INIT ======

  let quizLoadedOnce = false;

  function openQuiz() {
    document.documentElement.classList.add('quiz-boot');
    if (!modal) return;
    modal.style.display = 'block';
    document.documentElement.classList.add('no-scroll');
    setBackVisible(true);

    if (!quizLoadedOnce) {
      quizLoadedOnce = true;
      loadQuizProducts();
    }

    const introEl = document.querySelector('.quiz-intro');
    const steps = document.querySelectorAll('.quiz-question');
    introEl && (introEl.style.display = 'flex');
    steps.forEach(s => s.style.display = 'none');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  function closeQuiz(removeQuery = true) {
    if (!modal) return;
    modal.style.display = 'none';
    document.documentElement.classList.remove('no-scroll');
    document.documentElement.classList.remove('quiz-boot');

    if (removeQuery) {
      const u = new URL(location.href);
      u.searchParams.delete('quiz');
      history.replaceState({}, '', u);
    }
  }

  const params = new URLSearchParams(location.search);
  if ((params.get('quiz') || '').toLowerCase() === 'true' || params.has('quiz')) {
    openQuiz();
  }

  document.getElementById('cfg-open-quiz')?.addEventListener('click', (e) => {
    e.preventDefault();
    const u = new URL(location.href);
    u.searchParams.set('quiz', 'true');
    history.pushState({}, '', u); 
    openQuiz();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeQuiz();
  });


  const backBtn = document.getElementById('quiz-back');
  if (backBtn) {

    backBtn.addEventListener('click', () => {
      const steps = Array.from(document.querySelectorAll('.quiz-question'));
      const visibleStep = steps.find(step => step.style.display !== 'none');
      const introVisible = document.querySelector('.quiz-intro')?.style.display !== 'none';

      if (!visibleStep && introVisible) {
        const homeUrl = document.querySelector('.quiz-header .logo a')?.getAttribute('href') || '/';
        closeQuiz(false);
        window.location.href = homeUrl;
        return;
      }

      if (visibleStep && visibleStep.id === 'quiz-step-1') {
        visibleStep.style.display = 'none';
        const introEl = document.querySelector('.quiz-intro');
        if (introEl) introEl.style.display = 'flex';
        setBackVisible(false); 
        return;
      }

      if (visibleStep) {
        const idx = steps.indexOf(visibleStep);
        if (idx > 0) {
          steps[idx].style.display = 'none';
          steps[idx - 1].style.display = 'block';
          updateCTAForStep(steps[idx - 1]);
          setBackVisible(true);
        }
      }
    });
  }

  // ====== END INIT ======


  // ====== EVENT DELEGATION para TODOS los steps ======

  function isMultiStep(stepId){
    return stepId === 'quiz-step-4' || stepId === 'quiz-step-5';
  }

  function updateAnswersForStep(stepEl){
    const id = stepEl.id;
    const selectedNames = Array.from(stepEl.querySelectorAll('.quiz-option.selected .name'))
      .map(n => n.textContent.trim());
    if (id === 'quiz-step-1') {
      answers.step1_character = selectedNames[0] || null;
    } else if (id === 'quiz-step-2') {
      answers.step2_must = selectedNames[0] || null;
    } else if (id === 'quiz-step-3') {
      answers.step3_silhouette = selectedNames[0] || null;
    } else if (id === 'quiz-step-4') {
      answers.step4_necklines = selectedNames;
    } else if (id === 'quiz-step-5') {
      answers.step5_skirts = selectedNames;
    }
  }


  modal.addEventListener('click', (e)=>{
    const option = e.target.closest('.quiz-option');
    if(!option) return;
    const step = option.closest('.quiz-question');
    if(!step) return;

    const multi = isMultiStep(step.id);

    if (!multi) {
      if (option.classList.contains('selected')) {
        option.classList.remove('selected'); 
      } else {
        step.querySelectorAll('.quiz-option.selected').forEach(o => o.classList.remove('selected'));
        option.classList.add('selected');
      }
    } else {

      option.classList.toggle('selected');
    }

    updateAnswersForStep(step);
    updateCTAForStep(step);
  });


  // ====== Start Quiz ======
function onStartQuiz() {
  hide(document.querySelector('.quiz-intro'));
  const step1 = document.getElementById('quiz-step-1');
  show(step1);

  setBackVisible(true);
  updateCTAForStep(step1);

  window.scrollTo({ top: 0, behavior: 'smooth' });
}

document.querySelectorAll('.start-quiz').forEach(btn => {
  btn.addEventListener('click', onStartQuiz);
});

  // ====== Validadores ======
  function requireSingle(stepId, value, msg){
    if(!value){ alert(msg); return false; }
    goToStep(stepId, `quiz-step-${parseInt(stepId.split('-').pop(),10)+1}`); return true;
  }
  function requireMulti(stepId, arr, msg){
    if(!arr || arr.length===0){ alert(msg); return false; }
    goToStep(stepId, `quiz-step-${parseInt(stepId.split('-').pop(),10)+1}`); return true;
  }

  // ====== Botones Continue ======

  // STEP 1
  document.getElementById('quiz-step-1-continue')?.addEventListener('click', () => {
    goToStep('quiz-step-1', 'quiz-step-2');
    const s2 = document.getElementById('quiz-step-2');
    updateCTAForStep(s2);
  });

  // STEP 2
  document.getElementById('quiz-step-2-continue')?.addEventListener('click', () => {
    goToStep('quiz-step-2', 'quiz-step-3');
    const s3 = document.getElementById('quiz-step-3');
    updateCTAForStep(s3);
  });

  // STEP 3
  document.getElementById('quiz-step-3-continue')?.addEventListener('click', () => {
    goToStep('quiz-step-3', 'quiz-step-4');
    const s4 = document.getElementById('quiz-step-4');
    updateCTAForStep(s4);
  });

  // STEP 4 
  document.getElementById('quiz-step-4-continue')?.addEventListener('click', () => {
    goToStep('quiz-step-4', 'quiz-step-5');
    const s5 = document.getElementById('quiz-step-5');
    updateCTAForStep(s5);
  });

  // STEP 5 
  document.getElementById('quiz-step-5-continue')?.addEventListener('click', () => {
    goToStep('quiz-step-5','quiz-step-6');
  });

  // ====== Submit final ======

  const QUIZ_FILTERS_KEY = 'CFG_QUIZ_FILTERS';

  const finalForm = document.querySelector('.quiz-final-form');
  if (finalForm) {
    finalForm.addEventListener('submit', async (e) => {
      e.preventDefault();

      const emailInput = finalForm.querySelector('input[type="email"]');
      const subscribeInput = finalForm.querySelector('.checkbox input[type="checkbox"]');
      answers.email = emailInput?.value?.trim() || null;
      answers.subscribe = !!(subscribeInput?.checked);

      const topHandles = Array
        .from(document.querySelectorAll('#quiz-step-4 .quiz-option.selected'))
        .map(el => el.dataset.handle)
        .filter(Boolean);

      const bottomHandles = Array
        .from(document.querySelectorAll('#quiz-step-5 .quiz-option.selected'))
        .map(el => el.dataset.handle)
        .filter(Boolean);

    
      const filters = { tops: topHandles, bottoms: bottomHandles, ts: Date.now() };
      localStorage.setItem(QUIZ_FILTERS_KEY, JSON.stringify(filters));

      window.dispatchEvent(new CustomEvent('cfg:applyQuizFilters', { detail: filters }));

      try {
        const payload = {
          source: 'les-aimants-quiz',
          answers: {
            step1_character:  answers.step1_character  || 'No preference',
            step2_must:       answers.step2_must       || 'No preference',
            step3_silhouette: answers.step3_silhouette || 'No preference',
            step4_necklines: (answers.step4_necklines && answers.step4_necklines.length)
              ? answers.step4_necklines.join(', ')
              : 'No preference',
            step5_skirts: (answers.step5_skirts && answers.step5_skirts.length)
              ? answers.step5_skirts.join(', ')
              : 'No preference',
            email: answers.email || '',
            subscribe: !!answers.subscribe,
          },
          chosenHandles: filters
        };

        const form = new URLSearchParams();
        form.append('source', 'les-aimants-quiz');
        form.append('email', answers.email || '');
        form.append('subscribe', String(!!answers.subscribe));

        form.append('answers', JSON.stringify(payload.answers));
        form.append('tops', JSON.stringify(filters.tops || []));
        form.append('bottoms', JSON.stringify(filters.bottoms || []));

        form.append('answers.step1_character', answers.step1_character || 'No preference');
        form.append('answers.step2_must', answers.step2_must || 'No preference');
        form.append('answers.step3_silhouette', answers.step3_silhouette || 'No preference');
        form.append('answers.step4_necklines', (answers.step4_necklines || []).join(', '));
        form.append('answers.step5_skirts', (answers.step5_skirts || []).join(', '));
        form.append('chosenHandles.tops', (filters.tops || []).join('|'));
        form.append('chosenHandles.bottoms', (filters.bottoms || []).join('|'));
        form.append('chosenHandles.ts', String(filters.ts));

        form.append('answers__step1_character', answers.step1_character || 'No preference');
        form.append('answers__step2_must', answers.step2_must || 'No preference');
        form.append('answers__step3_silhouette', answers.step3_silhouette || 'No preference');
        form.append('answers__step4_necklines', (answers.step4_necklines || []).join(', '));
        form.append('answers__step5_skirts', (answers.step5_skirts || []).join(', '));
        form.append('chosenHandles__tops', (filters.tops || []).join('|'));
        form.append('chosenHandles__bottoms', (filters.bottoms || []).join('|'));
        form.append('chosenHandles__ts', String(filters.ts));

        fetch(WEBHOOK_URL, {
          method: 'POST',
          mode: 'no-cors',
          body: form
        }).catch(err => console.warn('[QUIZ] webhook fired (opaque/CORS)', err));


      } catch (err) {
        console.error('Webhook error:', err);
      }

      closeQuiz();
      const u = new URL(location.href);
      u.searchParams.delete('quiz');
      history.replaceState({}, '', u);

      const cfg = document.querySelector('.configurator');
      if (cfg) cfg.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  const skipLink = document.getElementById('quiz-skip');
  if (skipLink) {
    skipLink.addEventListener('click', (e) => {
      e.preventDefault();

      const topHandles = Array.from(
        document.querySelectorAll('#quiz-step-4 .quiz-option.selected')
      ).map(el => el.dataset.handle).filter(Boolean);

      const bottomHandles = Array.from(
        document.querySelectorAll('#quiz-step-5 .quiz-option.selected')
      ).map(el => el.dataset.handle).filter(Boolean);

      const filters = { tops: topHandles, bottoms: bottomHandles, ts: Date.now() };
      localStorage.setItem('CFG_QUIZ_FILTERS', JSON.stringify(filters));
      window.dispatchEvent(new CustomEvent('cfg:applyQuizFilters', { detail: filters }));

      closeQuiz(false);
      const href = skipLink.getAttribute('href') || '/pages/design-your-dress';
      history.pushState({}, '', href); 
    }, { once: true });
  }


});


// ==============================
//  UI Quiz/Configurator bridge
//  - Topbar text swap
//  - Reset button at bottom-left panel
// ==============================

document.addEventListener('DOMContentLoaded', () => {
  // ===== Config =====
  const QUIZ_FILTERS_KEY = 'CFG_QUIZ_FILTERS';

  // ===== DOM =====
  const $link    = document.getElementById('cfg-open-quiz');   
  const $text    = document.querySelector('.cfg-topbar p');   
  const $reset   = document.getElementById('cfg-clear-quiz'); 


  const getFilters = () => {
    try { return JSON.parse(localStorage.getItem(QUIZ_FILTERS_KEY) || '{}'); }
    catch { return {}; }
  };
  const hasAnyFilters = (f) => {
    if (!f) return false;
    const t = Array.isArray(f.tops) ? f.tops.length : 0;
    const b = Array.isArray(f.bottoms) ? f.bottoms.length : 0;
    return (t + b) > 0;
  };

  function setUI(applied){
    if ($link){
      if (applied){
        $link.setAttribute('hidden','');
        $link.setAttribute('aria-hidden','true');
      } else {
        $link.removeAttribute('hidden');
        $link.setAttribute('aria-hidden','false');
      }
    }
    if ($text){
      if (applied){
        $text.removeAttribute('hidden');
        $text.setAttribute('aria-hidden','false');
      } else {
        $text.setAttribute('hidden','');
        $text.setAttribute('aria-hidden','true');
      }
    }
    if ($reset){
      if (applied){
        $reset.removeAttribute('hidden');
        $reset.setAttribute('aria-hidden','false');
      } else {
        $reset.setAttribute('hidden','');
        $reset.setAttribute('aria-hidden','true');
      }
    }
  }

  function resetQuizFilters(){
    localStorage.removeItem(QUIZ_FILTERS_KEY);

    const empty = { tops: [], bottoms: [], ts: Date.now() };
    window.dispatchEvent(new CustomEvent('cfg:applyQuizFilters', { detail: empty }));

    setUI(false);

    const cfg = document.querySelector('.configurator');
    if (cfg) cfg.scrollIntoView({ behavior:'smooth', block:'start' });
  }

  if ($reset){
    $reset.addEventListener('click', (e) => {
      e.preventDefault();
      resetQuizFilters();
    });
  }

  window.addEventListener('cfg:applyQuizFilters', (ev) => {
    const applied = hasAnyFilters(ev?.detail);
    setUI(applied);
  });

  setUI(hasAnyFilters(getFilters()));
});
